import { ChangeDetectionStrategy, Component, computed, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TempNgxButtonComponent } from '@client-monorepo/common/ui-components';
import { GeneralErrorService } from '../../data-access/services/general-error.service';
import { ERROR_DATA_CONFIG } from '../../data-access/constants/error-data-config';
import { ErrorImageComponent } from '../error-image/error-image.component';
import { InternetConnectionService } from '../../data-access/services/internet-connection.service';
import { Subscription } from 'rxjs';
import { GeneralErrorTypes } from '../../data-access/models/general-error-types';

@Component({
  selector: 'common-network-error-page',
  standalone: true,
  imports: [CommonModule, TempNgxButtonComponent, ErrorImageComponent],
  templateUrl: './error-page.component.html',
  styleUrl: './error-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorPageComponent implements OnInit, OnDestroy {
  disableButton = signal<boolean>(false);
  generalErrorService = inject(GeneralErrorService);
  internetConnectionService = inject(InternetConnectionService);
  error = computed(() => {
    return this.generalErrorService.error();
  });
  config = computed(() => {
    const error = this.error();
    return error ? ERROR_DATA_CONFIG[error] : null;
  });
  onlineSubscription!: Subscription;
  offlineSubscription!: Subscription;

  ngOnInit() {
    this.checkInternetConnection();
  }

  checkInternetConnection(): void {
    this.onlineSubscription = this.internetConnectionService.getOnlineEvent().subscribe(() => {
      this.generalErrorService.error.set(null);
    });
    this.offlineSubscription = this.internetConnectionService.getOfflineEvent().subscribe(() => {
      this.generalErrorService.error.set(GeneralErrorTypes.INTERNET_ERROR);
    });
  }

  handleRetry(): void {
    this.disableButton.set(true);
    window.location.reload();
  }

  returnToHome() {
    this.disableButton.set(true);
    window.location.href = '/';
  }
  ngOnDestroy(): void {
    this.onlineSubscription?.unsubscribe();
    this.offlineSubscription?.unsubscribe();
  }
}
